
<template>
  <div>
    <base-modal :title="title" :width="width" :visible="visible" @cancel="open(false)">
      <div slot="modalBody">
        <a-form :form="form" class="importForm">
          <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="模板下载">
            <a-button type="default" @click="downloadFile">模板下载</a-button>
          </a-form-item>
          <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="导入试卷信息">
            <a-upload
              name="file"
              :fileList="fileList"
              :remove="handleRemove"
              :beforeUpload="beforeUpload"
              @change="handleChange"
            >
              <a-button>
                <a-icon type="upload" />选择文件
              </a-button>
            </a-upload>
          </a-form-item>
          <a-form-item :wrapper-col="{ span: 12, offset: 12 }">
            <a-button style="margin-right:10px;" @click="cancel">取消</a-button>
            <a-button
              accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
              type="primary"
              :disabled="fileList.length === 0"
              :loading="uploading"
              @click="handleUpload"
            >上传</a-button>
          </a-form-item>
        </a-form>
      </div>
    </base-modal>
  </div>
</template>

<script>
import baseModal from '@/CrComponents/Modal/Modal.vue'
// import { paperImport } from '@/api/paper'
export default {
  name: 'ImportForm',
  components: {
    baseModal
  },
  data () {
    return {
      title: '导入试卷信息',
      width: 600,
      type: 'add', // 弹窗的类型:add:新增|modify:修改|del:删除
      form: this.$form.createForm(this, { name: 'importForm' }),
      visible: false,
      defaultModel: {},
      model: {},
      labelCol: {
        xs: { span: 24 },
        sm: { span: 5 }
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 16 }
      },
      projectList: [],
      fileList: [],
      uploading: false
    }
  },
  methods: {
    // 设置类型
    setType (type) {
      this.type = type
    },
    // 设置标题
    setTitle (title) {
      this.title = title
    },
    // 设置model参数 修改时传入
    setModel (model) {
      this.model = Object.assign({}, model)
    },
    // 打开or关闭，修改的窗口先获取详情
    open (flag) {
      this.formClear()
      this.visible = flag
    },
    // 清空表单
    formClear () {
      this.form.setFieldsValue({ fileList: [] })
    },
    cancel () {
      this.formClear()
      this.open(false)
    },
    // 模板下载
    downloadFile () {
      // vehicleTemplate({ id: this.model.id }).then(res => {
      //   var filename = this.model.name + '导入模板'
      //   const url = window.URL.createObjectURL(res)
      //   const link = document.createElement('a')
      //   link.style.display = 'none'
      //   link.href = url
      //   link.setAttribute('download', filename + '.xlsx')
      //   document.body.appendChild(link)
      //   link.click()
      // })
    },
    handleRemove (file) {
      const index = this.fileList.indexOf(file)
      const newFileList = this.fileList.slice()
      newFileList.splice(index, 1)
      this.fileList = newFileList
    },
    // 选择文件
    beforeUpload (file) {
      var fileName = file.name.split('.')
      var type = fileName[fileName.length - 1]

      if (type === 'xls' || type === 'xlsx') {
        this.fileList = [file]
      } else {
        this.$message.error('只支持xls、xlsx格式的文件')
      }
      return false
    },
    handleChange (info) {
      let fileList = [...info.fileList]
      fileList = fileList.slice(-1) // 1. Limit the number of uploaded files.Only to show one recent uploaded files, and old ones will be replaced by the new
      // 2. read from response and show file link
      fileList = fileList.map(file => {
        if (file.response) {
          file.url = file.response.url
        }
        return file
      })
      this.fileList = fileList
    },
    // 上传
    handleUpload () {
      const { fileList } = this
      const formData = new FormData()
      fileList.forEach(file => {
        console.log('file', file)
        formData.append('file', file.originFileObj)
        formData.append('timetableId', this.model.id)
      })
      this.uploading = true
      // paperImport(formData).then(res => {
      //   this.uploading = false
      //   if (res.status === 0) {
      //     this.fileList = []
      //     this.$message.success('导入成功！')
      //     this.$emit('refreshTable')
      //     this.open(false)
      //   } else {
      //     this.fileList = []
      //     // this.$message.error(res.info.message)
      //     const message = res.info.message.split(';')
      //     this.$notification.error({
      //       message: '导入失败',
      //       description: (h) => {
      //         var tipDom = []
      //         message.map(item => {
      //           tipDom.push(h('span', item))
      //           tipDom.push(h('br'))
      //         })
      //         return h('span', tipDom)
      //       },
      //       style: {
      //         width: '500px',
      //         marginLeft: `-110px`
      //       },
      //       duration: 0
      //     })
      //   }
      // }).catch(error => {
      //   this.uploading = false
      // })
    }
  }
}
</script>
